import { type FC, type PropsWithChildren } from 'react';
import cn from 'classnames';

import { createBgSet } from '@/common/lib/createBgSet';
import { type LotteryTicketType } from '@/common/types/lottery';

import { lotteryBackgrouds } from '../config';
import { SideEffects } from '../LotteryContainer/SideEffects/SideEffects';

import css from './styles.module.scss';

interface LotteryBgWrapperProps extends PropsWithChildren {
  type: LotteryTicketType;
  className?: string;
}

const LotteryBgWrapper: FC<LotteryBgWrapperProps> = ({
  type,
  className,
  children,
}) => {
  const { png, webp } = lotteryBackgrouds[type];
  const bgImageBase = `
    linear-gradient(270deg, #181A20 0%, rgba(24, 26, 32, 0.00) 12.5%),
    linear-gradient(270deg, rgba(24, 26, 32, 0.00) 87.5%, #181A20 100%),
    linear-gradient(180deg, rgba(24, 26, 32, 0.00) 71.63%, #181A20 100%),
  `;

  return (
    <div
      style={{
        backgroundImage: bgImageBase + createBgSet(png, webp),
        backgroundPositionX: 0,
        backgroundPositionY: '-60%',
      }}
      className={cn(css.lotteryBgWrapper, className)}
    >
      <SideEffects />
      {children}
    </div>
  );
};

export { LotteryBgWrapper };
